import { Abacus } from "core/Abacus.Core";
import { Class } from "core/Abacus.Utilities";

class CommentEntry extends Class {
	constructor(element) {
		super();
		this.element = $(element);
		this.$commentText = this.element.find('#commentText');
		this.$commentButton = this.element.find('#CommentInsertBtn');
		this.setUpEvents();
	}

	setUpEvents() {
		var self = this;
		this.$commentText.on('focus', function(){
			self.open();
		});
	}

	open() {
		this.$commentButton.prop('disabled', false);
		this.element.addClass('open');
	}

	close() {
		this.$commentButton.prop('disabled', true);
		this.element.removeClass('open');
	}

}

export { CommentEntry };



// WEBPACK FOOTER //
// ./Javascript/core/classes/comments/comments.class.js